import { updateLinksAttributes } from '../../../utils/handleAttributes';

export default function fairMainCards() {
  const widgetName = 'fairMainCards';
  const widgetOpts = fairMainCardsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomFairCards(data.items, $widget);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });
}

function createCustomFairCards(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);

    $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">${Title}</span>
              </div>
            <div class="hover-content"></div>
          </div>`);

    updateLinksAttributes(URL, Title, $cardItem);

    validateUrl(URL, $cardItem);
  });
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}
